import React, { Fragment, Component } from 'react';
import FontAwesome from 'react-fontawesome';
import { HotKeys } from 'react-hotkeys';
import { connect } from 'react-redux';
import actions from '../../actions';
import Button from '../../components/Button/Button';
import TextBox from '../../components/TextBox/TextBox';

import './Login.scss';

const keyMap = {
    submit: 'enter'
};

export class Login extends Component {
    constructor(props) {
        super(props);

        this.accessCode = React.createRef();
        this.lastName = React.createRef();

        this.state = {
            isDirty: false,
            data: {
                lastName: '',
                accessCode: ''
            },
            error: {
                lastName: false,
                accessCode: false
            }
        };
    }

    keyHandlers() {
        return {
            submit: () => (!this.isButtonDisabled() ? this.submit() : null)
        };
    }

    validateCustomer() {
        this.props.validateCustomer(
            {
                lastName: this.state.data.lastName,
                accessCode: this.state.data.accessCode,
                isDirty: this.state.isDirty
            },
            this.props.app.deploy.env
        );
    }

    submit() {
        if (!this.props.customer.isLoading) {
            this.validateCustomer();
        }
    }

    scrubValueToState(field) {
        const regexMap = {
            lastName: /[^A-Za-z]/gi,
            accessCode: /[^0-9]/g
        };
        this.setState(state => {
            state.data[field.name] = field.value
                .trim()
                .replace(regexMap[field.name], '')
                .toLowerCase();
            return state;
        });
    }

    validateField(field) {
        const regexMap = {
            lastName: /[^A-Za-z,'. -]/g,
            accessCode: /\D/g
        };
        return {
            name: field.name,
            hasError: regexMap[field.name].test(field.value.trim())
        };
    }

    setError(field) {
        const { hasError } = this.validateField(field);

        this.setState(state => {
            state.error[field.name] = hasError;
            return state;
        });
    }

    setDirty(target) {
        const field = target.name;
        const map = {
            accessCode: this.props.customer.accessCode,
            lastName: this.props.customer.lastName
        };

        const hasInputChanged = map[field] !== target.value;

        if (this.props.customer.isValid && hasInputChanged) {
            this.setState(state => {
                state.isDirty = true;
                return state;
            });
        }
    }

    handleLastNameChange({ target }) {
        this.setDirty(target);
        this.setError(target);
        this.scrubValueToState(target);
    }

    handleAccessCodeChange({ target }) {
        this.setDirty(target);
        this.setError(target);
        this.scrubValueToState(target);
    }

    isButtonDisabled() {
        const hasError = this.state.error.accessCode || this.state.error.lastName;

        return (
            this.props.customer.isLoading ||
            hasError ||
            this.state.data.accessCode.length < 6 ||
            this.state.data.lastName.length < 1
        );
    }

    render() {
        return (
            <div className="login">
                <HotKeys keyMap={keyMap} handlers={this.keyHandlers()}>
                    <div className="form">
                        <TextBox
                            marginRight={8}
                            marginLeft={0}
                            inputRef={this.lastName}
                            onChange={e => this.handleLastNameChange(e)}
                            name="lastName"
                            placeholder="Policyholder last name"
                            autoComplete="family-name"
                            error={this.state.error.lastName}
                            helper={this.state.error.lastName ? 'Enter only letters' : null}
                            datacy="helper-box-letters"
                        />
                        <TextBox
                            marginRight={8}
                            marginLeft={0}
                            inputRef={this.accessCode}
                            onChange={e => this.handleAccessCodeChange(e)}
                            name="accessCode"
                            placeholder="Access code"
                            error={this.state.error.accessCode}
                            helper={this.state.error.accessCode ? 'Enter only numbers' : null}
                            datacy={'helper-box-numbers'}
                        />
                        <Button
                            heapAttribute="login"
                            type="primary"
                            marginTop={0}
                            marginBottom={0}
                            disabled={this.isButtonDisabled()}
                            onClick={e => this.submit(e)}
                            text="Access my quote"
                            isUpperCase={false}
                            datacy="access-my-quote"
                        />
                    </div>
                    <div className="helper hasError auth-error" datacy="helper-invalid">
                        <ErrorMsg customer={this.props.customer} state={this.state} />
                    </div>
                </HotKeys>
            </div>
        );
    }
}

const ErrorMsg = ({ customer, state }) => {
    const { isValid, isLoading, hasError } = customer;

    //invalid customer
    if (!isLoading && isValid === false) {
        return (
            <Fragment>
                <FontAwesome name="exclamation-triangle" />
                Policyholder last name or Access code is incorrect.
            </Fragment>
        );
    }

    // any other error
    if (hasError) {
        return `Something went wrong, please try again later!`;
    }

    return null;
};

function mapStoreToProps(store) {
    return {
        customer: store.customer,
        app: store.app
    };
}

function mapDispatchToProps(dispatch) {
    return {
        validateCustomer: (data, env) =>
            dispatch(actions.apigee.requestAccessToken({ env, ...data }))
    };
}

export default connect(
    mapStoreToProps,
    mapDispatchToProps
)(Login);



// WEBPACK FOOTER //
// ./src/containers/Login/Login.jsx